var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessageSent = function SvgMessageSent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86689 4.86865H11.455M4.86689 8.16016H9.808M8.45319 14.4585L8.16166 14.75L5.69111 12.2794H3.22056C2.56532 12.2794 1.93693 12.0191 1.47361 11.5558C1.01029 11.0925 0.75 10.4641 0.75 9.80882V3.22059C0.75 2.56535 1.01029 1.93694 1.47361 1.47362C1.93693 1.01029 2.56532 0.75 3.22056 0.75H13.1028C13.758 0.75 14.3864 1.01029 14.8497 1.47362C15.313 1.93694 15.5733 2.56535 15.5733 3.22059V7.75M9.8087 12.2788H14.7498M13.103 14.7488L15.5735 12.2782L13.103 9.80762",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageSent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messageSent.afe19f5e.svg";
export { ForwardRef as ReactComponent };